

export const environment = {
  onboardInfoCollection_isEnabled: true,
  onboardDocumentCollection_isEnabled: true,
  onboard_preboarding_forms_isEnabled: false,
  production: false,
  orgname: 'NAQUA',

  parser_enabled: true,

   SERVER_URL: 'https://naquacareers.crescoworks.com/',

  PARSER_URL: "https://parser.crescoworks.com/ParsePdf",
};
